export default class Config {
  public static RecaptchaKey: string;
}